const NOTIFICATION_POSITION_NONE = 'none';
const NOTIFICATION_POSITION_PANEL = 'panel';
const NOTIFICATION_POSITION_TRANSFER = 'transfer';

export default {
  none: NOTIFICATION_POSITION_NONE,
  panel: NOTIFICATION_POSITION_PANEL,
  transfer: NOTIFICATION_POSITION_TRANSFER,
};
